// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"d6802ac3","192":"a0568633","698":"ef512f44"}[chunkId] + ".chunk.js";
};